import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { HiOutlineExternalLink } from "react-icons/hi";


export default function RedirectComponent({ verificationData, setStepNumber, setIsShowLoader }) {

  const redirectToVeriffDashboard = () => {
    if (!verificationData) { return false; }
    setIsShowLoader(true);
    const url = verificationData.url;
    window.open(url, "_blank");
  };

  return (
    <Row className='py-2 pb-4'>
      <Col sm={12}>
        <h5>Document Verification</h5>
        <p>To complete your verification, please choose one of the following methods. You can either upload your documents directly from your device or use Veriff's verification service for a seamless experience.</p>
        <hr />
      </Col>

      <Col sm={12}>
        <div className='mt-3 d-flex justify-content-around'>
          <Button onClick={() => setStepNumber(3)}>
            Upload Files from Your Device
          </Button>
          <Button onClick={redirectToVeriffDashboard} className='d-flex align-items-center gap-2'>
            <span>
              Use Veriff Verification Service
            </span>
            <HiOutlineExternalLink size={18} />
          </Button>
        </div>
      </Col>
    </Row>
  )
}
